import ReactHtmlParser from 'react-html-parser';
import i18n from 'i18next';

export const languages = [
  'pt', 'en', 'es'
];

export const getBrowserLanguage = () => navigator.language.slice(0, 2);

export const getCurrentLanguage = () => {
  const cachedLanguage = localStorage.getItem('@currentLanguage');

  if(cachedLanguage === null) {
    const isValidLanguage = languages.find(lang => lang === getBrowserLanguage()) !== undefined;

    return isValidLanguage ? getBrowserLanguage() : 'en';
  } else { 
    return cachedLanguage;
  }
};

export const changeLanguage = (language) => {
  i18n.changeLanguage(language);
  localStorage.setItem('@currentLanguage', language);
};

export const htmlT = (t, str, options) => {
  const unescapeHTML = (html) => {
    const escapeEl = document.createElement('textarea');
    escapeEl.innerHTML = html;
    return escapeEl.textContent || str;
  };
  return ReactHtmlParser(unescapeHTML(t(str, options)));
};
